/* eslint-disable @typescript-eslint/class-name-casing */
import * as React from 'react'
import {
  commonProps,
  CommonProps,
  SupportedProps,
  flexItemProps,
  FlexItemProps
} from '@bestyled/system'
import styled from 'styled-components'
import { ViewBase } from './ViewBase'

export interface ViewProps extends FlexItemProps, CommonProps, SupportedProps {
  style?: any
  as?: string | React.FC<any>
  ref?: any
  itemType?: string
}

/** The View component is a generic container that has margin, padding, width, height and position */
export const View = styled(ViewBase<ViewProps>('View$'))`
  ${flexItemProps} ${commonProps}
` as React.FC<React.PropsWithChildren<ViewProps>>

export default View
